export default __webpack_public_path__ + "static/media/howitwork-bg.14727f71.svg";